let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("f7XHA")).then(() => parcelRequire('c2Dmg'));